<template lang='pug'>
  .fpui-layout-resizer(ref="resizer")
    .cursor.cursor-horizontal(v-if="orientation==='horizontal'")
      i.fpui.fpui-chevron-left
      i.fpui.fpui-chevron-right
    .cursor.cursor-vertical(v-if="orientation==='vertical'")
      i.fpui.fpui-chevron-up
      i.fpui.fpui-chevron-down
    i.arrow-actions.fpui.fpui-angle-double-right(@click="moveRight",v-if="needArrow('right')")
    i.arrow-actions.fpui.fpui-angle-double-left(@click="moveLeft",v-if="needArrow('left')")
    i.arrow-actions.fpui.fpui-angle-double-up(@click="moveUp",v-if="needArrow('up')")
    i.arrow-actions.fpui.fpui-angle-double-down(@click="moveDown",v-if="needArrow('down')")
</template>

<script>
import interact from 'interactjs'
export default {
  props: {
    reference: {
      type: String,
      default: 'previousSibling'
    }
  },
  data () {
    return {
      orientation: null
    }
  },
  methods: {
    needArrow (type) {
      if (!this.orientation) return false
      switch (type) {
        case 'right':
          if (this.reference === 'previousSibling') {
            return this.orientation === 'horizontal' && this.getSize() <= 32
          }
          return this.orientation === 'horizontal' && this.getSize() > 32
        case 'left':
          if (this.reference === 'previousSibling') {
            return this.orientation === 'horizontal' && this.getSize() > 32
          }
          return this.orientation === 'horizontal' && this.getSize() <= 32
        case 'up':
          if (this.reference === 'previousSibling') {
            return this.orientation === 'vertical' && this.getSize() > 32
          }
          return this.orientation === 'vertical' && this.getSize() <= 32
        case 'down':
          if (this.reference === 'previousSibling') {
            return this.orientation === 'vertical' && this.getSize() <= 32
          }
          return this.orientation === 'vertical' && this.getSize() > 32
      }
    },
    moveDown () {
      if (this.reference === 'previousSibling') {
        this.referenceElement.style.height = this.referenceElement.getAttribute('data-init-height') + 'px'
        this.update('offsetHeight')
      } else {
        this.referenceElement.style.height = '32px'
        this.update('offsetHeight')
      }
    },
    moveUp () {
      if (this.reference === 'previousSibling') {
        this.referenceElement.style.height = '32px'
        this.update('offsetHeight')
      } else {
        this.referenceElement.style.height = this.referenceElement.getAttribute('data-init-height') + 'px'
        this.update('offsetHeight')
      }
    },
    moveLeft () {
      if (this.reference === 'previousSibling') {
        this.referenceElement.style.width = '32px'
        this.update('offsetWidth')
      } else {
        this.referenceElement.style.width = this.referenceElement.getAttribute('data-init-width') + 'px'
        this.update('offsetWidth')
      }
    },
    moveRight () {
      if (this.reference === 'previousSibling') {
        this.referenceElement.style.width = this.referenceElement.getAttribute('data-init-width') + 'px'
        this.update('offsetWidth')
      } else {
        this.referenceElement.style.width = '32px'
        this.update('offsetWidth')
      }
    },
    update (param) {
      this.toggleCollapse(param, this.$refs.resizer.previousSibling, 'prev')
      this.toggleCollapse(param, this.$refs.resizer.nextSibling, 'next')
      this.$forceUpdate()
      this.$emit('resize')
    },
    toggleCollapse (param, elem, type) {
      if (elem[param] <= 32) {
        elem.className = 'collapse collapse-' + this.orientation + '-' + type
      } else {
        elem.className = ''
      }
    },
    getSize () {
      if (this.orientation === 'vertical') {
        return (this.referenceElement && this.referenceElement.offsetHeight) || 0
      }
      return (this.referenceElement && this.referenceElement.offsetWidth) || 0
    },
    setHeight (data) {
      if (this.referenceElement.style.height < data.height) {
        this.referenceElement.style.height = data.height
      }
      if (data.type === 'cancel') {
        this.referenceElement.style.height = data.height
      }
    }
  },
  computed: {
    referenceElement () {
      return this.$refs.resizer && this.$refs.resizer[this.reference]
    }
  },
  mounted () {
    this.referenceElement.setAttribute('data-init-width', this.referenceElement.offsetWidth)
    this.referenceElement.setAttribute('data-init-height', this.referenceElement.offsetHeight)

    this.orientation = this.$parent.orientation
    this.$emit('ready')
    interact(this.$refs.resizer)
    .draggable({
      onstart: event => {
        event.target.setAttribute('data-size', this.getSize())
      },
      onmove: event => {
        if (this.orientation === 'vertical') {
          let y = (parseFloat(event.target.getAttribute('data-y')) || 0) + event.dy
          let height = parseFloat(event.target.getAttribute('data-size')) || 0
          event.target.setAttribute('data-y', y)
          if (this.reference === 'nextSibling') {
            y = -y
          }
          let h = height + y
          if (h < 32) h = 32
          this.referenceElement.style.height = h + 'px'
          this.update('offsetHeight')
        } else {
          let x = (parseFloat(event.target.getAttribute('data-x')) || 0) + event.dx
          let width = parseFloat(event.target.getAttribute('data-size')) || 0
          event.target.setAttribute('data-x', x)
          if (this.reference === 'nextSibling') {
            x = -x
          }
          let w = width + x
          if (w < 32) w = 32
          this.referenceElement.style.width = w + 'px'
          this.update('offsetWidth')
        }
      },
      onend: event => {
        event.target.setAttribute('data-x', 0)
        event.target.setAttribute('data-y', 0)
        event.target.setAttribute('data-size', 0)
        this.$emit('end')
      }
    })
  }
}
</script>

<style lang='less'>
  @import '~@/shared/styles/_variables.less';
  .fpui-layout-resizer {
    z-index:200;
    .arrow-actions {
      color:#bbb;
      z-index: 3;
      position: absolute;
      font-size:20px;
      background:white;
      border-radius:4px;
      cursor:pointer;
      &:hover {
        color:white;
        background:@blue;
      }
    }
    .fpui-angle-double-right {
      left:15px;
    }
    .fpui-angle-double-left {
      right:15px;
    }
    .fpui-angle-double-up {
      bottom:15px;
      right:15px;
    }
    .fpui-angle-double-down {
      top:15px;
      right:15px;
    }


    .cursor {
      background:@blue;
      color:@white;
      cursor:pointer;
      display:none;
      z-index: 2;
      top:50%;
      left:50%;
      position: absolute;
      border-radius: 100%;
      height:30px;
      width:30px;
      font-size:15px;
      transform:translate(-50%,-50%);
      i {
        position:absolute;
        &.fpui-chevron-left {
          left:0;
          top:45%;
          transform: translateY(-50%);
        }
        &.fpui-chevron-right {
          right:0;
          top:45%;
          transform: translateY(-50%);
        }
        &.fpui-chevron-up {
          top:0;
          left:50%;
          transform: translateX(-50%);
        }
        &.fpui-chevron-down {
          bottom:0;
          left:50%;
          transform: translateX(-50%);
        }
      }
    }
    &:hover {
      .cursor {
        display: block;
      }
    }
  }
</style>
